import { defaultFormItemLayout, rules } from '../../../../../modules/FormItems'
import React from 'react'
import { Col, Form, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import useFetchSelectUrl from '../../../../../elements/Hooks/useFetchSelectUrl'
import { compose } from 'recompose'
import withData from '../../../../../elements/Select/withData'
import withKeyValue from '../../../../../elements/HOC/WithKeyValue'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'

function getTemplates (bankID) {
  if (isEmpty(bankID)) return []
  if (['lenderContracts/10333942150194'].includes(bankID)) return ['BSB']
}

function PayrollClaimCSVForm (props) {
  const { payrollClaim } = props
  const { getFieldDecorator, resetFields, getFieldValue } = props.form
  const company = get(payrollClaim, 'company._id')
  const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
  const [BankSelectCmp] = useFetchSelectUrl(
    {
      name: 'banks',
      url: url,
      cache: true,
      forceFetch: true,
    },
    [url],
  )
  const TemplateSelect = compose(
    withData({ data: getTemplates(getFieldValue('bank._id')) }),
    withKeyValue(),
    withSort,
  )(CustomSelect)
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Bank'}>
            {getFieldDecorator('bank._id', {
              rules: rules.select,
            })(
              <BankSelectCmp
                keyAtr={'_id'}
                valueAtr={'title'}
                placeholder={'Bank Account'}
                onChange={() => {
                  resetFields('template')
                }}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Template'}>
            {getFieldDecorator('template', {
              rules: rules.select,
            })(<TemplateSelect/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

PayrollClaimCSVForm.propTypes = {}
PayrollClaimCSVForm.defaultProps = {}

export default Form.create()(PayrollClaimCSVForm)
